export const API_USER_DEFINED_MESSAGE = {
    FAILED: 'Oops, looks like some data is not loading. Please try again later.',
    EMPTY_RESPONSE: 'There were no results found. Please try again later.',
    EMPTY_FILTER_RESPONSE: 'Hmm...looks like there were no matches found. Please try again later.',
    EMPTY_ACCEPTED_STATUS: 'Currently, there is no invitee with an Accepted status.'
};